export interface TimelineEntry {
  date: string;
  title: string;
  text: string;
}

export interface Collection {
  id: string;
  title: string;
  category: string;
  categorySlug: string;
  summary: string;
  cover: string;
  tags: string[];
  updatedAt: string;
  views: number;
  entries: TimelineEntry[];
}

export const categories = [
  {
    slug: 'romance',
    name: '情感风波',
    desc: '从捕风捉影到大方回应，把恋爱、分手、婚姻相关的传闻按时间顺序理清楚。',
    icon: 'ri-heart-3-line',
  },
  {
    slug: 'career',
    name: '事业争议',
    desc: '解约、换角、番位、退团，牵动职业走向的关键节点一次看全。',
    icon: 'ri-flight-takeoff-line',
  },
  {
    slug: 'money',
    name: '金钱纠葛',
    desc: '版权分成、片酬分歧、带货数据质疑，涉及真金白银的争议复盘。',
    icon: 'ri-coins-line',
  },
  {
    slug: 'production',
    name: '剧组幕后',
    desc: '剧本改动、署名之争、拍摄延期，台前看不到的制作端故事。',
    icon: 'ri-clapperboard-line',
  },
  {
    slug: 'variety',
    name: '综艺花絮',
    desc: '剪辑争议、名场面、嘉宾互动，综艺播出前后的完整脉络。',
    icon: 'ri-movie-2-line',
  },
  {
    slug: 'brand',
    name: '商务代言',
    desc: '代言更替、品牌联动、合作终止，商业合作里的是非曲折。',
    icon: 'ri-store-3-line',
  },
];

export const collections: Collection[] = [
  {
    id: 'top-love-timeline',
    title: '某顶流恋情时间线全记录',
    category: '情感风波',
    categorySlug: 'romance',
    summary:
      '从同款单品被扒，到深夜同框被拍，再到工作室统一口径回应，这段传了大半年的绯闻终于有了完整的前因后果。本篇按时间顺序把关键节点逐一梳理，方便一次看个够。',
    cover:
      'https://readdy.ai/api/search-image?query=Abstract%20warm%20toned%20image%20of%20two%20blurred%20silhouettes%20standing%20apart%20under%20soft%20amber%20light%20with%20bokeh%20city%20night%20background%2C%20stylized%20editorial%20photography%2C%20muted%20coral%20and%20cream%20palette%2C%20minimal%20composition%2C%20high%20detail&width=900&height=650&seq=guagua-romance-01&orientation=landscape',
    tags: ['同款被扒', '深夜同框', '工作室回应', '时间线'],
    updatedAt: '2026-08-28',
    views: 486230,
    entries: [
      {
        date: '2026-03-11',
        title: '同款单品首次被扒出',
        text: '一组街拍照片中出现的帽子与围巾被网友指出与另一位艺人的私服高度一致，相关话题开始在社交平台小范围发酵。当事双方当时均未回应。',
      },
      {
        date: '2026-05-02',
        title: '行程高度重合引发猜测',
        text: '有网友整理了两人近三个月的公开行程，发现多次出现在同一城市、同一时间段。讨论热度明显上升，但依然没有实锤。',
      },
      {
        date: '2026-06-19',
        title: '深夜同框画面流出',
        text: '一段夜间拍摄的画面显示两人先后进入同一栋公寓。画面较为模糊，辨识度有限，但足以让话题冲上热榜。',
      },
      {
        date: '2026-07-08',
        title: '双方工作室统一回应',
        text: '两边工作室几乎在同一时间发布了措辞相近的声明，表示「只是朋友」。回应并未平息讨论，反而引发对声明细节的新一轮解读。',
      },
      {
        date: '2026-08-28',
        title: '后续：相关话题逐渐降温',
        text: '随着新剧宣传期结束，相关讨论热度回落。目前双方均未再就此事表态，事件暂时告一段落。',
      },
    ],
  },
  {
    id: 'actor-contract-dispute',
    title: '实力派演员解约风波始末',
    category: '事业争议',
    categorySlug: 'career',
    summary:
      '一纸解约函把合作多年的艺人与经纪公司推上风口。从取关、清空动态到正式发函，再到双方各执一词的声明，这是一场典型的合约拉扯。',
    cover:
      'https://readdy.ai/api/search-image?query=Abstract%20cinematic%20image%20of%20an%20empty%20spotlight%20on%20a%20dark%20stage%20with%20warm%20crimson%20and%20amber%20light%20streaks%2C%20stylized%20theatrical%20atmosphere%2C%20minimal%20dramatic%20composition%2C%20moody%20editorial%20photography%2C%20high%20detail&width=900&height=650&seq=guagua-career-02&orientation=landscape',
    tags: ['合约纠纷', '解约函', '取关', '双方声明'],
    updatedAt: '2026-08-21',
    views: 372910,
    entries: [
      {
        date: '2026-04-15',
        title: '社交账号突然清空',
        text: '当事人社交账号的简介与部分动态被清空，有粉丝发现其已不再关注公司官方账号，解约传闻开始出现。',
      },
      {
        date: '2026-05-30',
        title: '新项目官宣未挂公司渠道',
        text: '一个新签约项目的宣传物料中，未出现原经纪公司的署名。业内人士开始判断双方合作关系可能已经生变。',
      },
      {
        date: '2026-07-02',
        title: '解约函内容被曝光',
        text: '一份盖有公章的解约通知在网络流传，涉及分成比例与资源安排等条款。经纪公司随后回应称文书「存在争议」。',
      },
      {
        date: '2026-08-21',
        title: '双方就后续合作各发声明',
        text: '公司强调合约仍在有效期内，当事人一方则表示已按流程履行通知义务。双方均表示会通过合法途径解决分歧。',
      },
    ],
  },
  {
    id: 'music-copyright-case',
    title: '音乐人版权纠纷完整梳理',
    category: '金钱纠葛',
    categorySlug: 'money',
    summary:
      '一首传唱度很高的歌曲，牵出词曲署名、授权范围与平台分成三方的连环争议。本篇把复杂的版权关系拆成几个易懂的阶段。',
    cover:
      'https://readdy.ai/api/search-image?query=Abstract%20flat%20lay%20of%20scattered%20paper%20documents%2C%20a%20classic%20microphone%20and%20warm%20amber%20desk%20lamp%20light%20on%20a%20cream%20surface%2C%20stylized%20editorial%20still%20life%2C%20muted%20gold%20and%20brown%20palette%2C%20minimal%20composition%2C%20high%20detail&width=900&height=650&seq=guagua-money-03&orientation=landscape',
    tags: ['版权', '署名', '分成', '平台授权'],
    updatedAt: '2026-08-14',
    views: 258440,
    entries: [
      {
        date: '2026-02-20',
        title: '词曲署名顺序引发讨论',
        text: '歌曲上线后在音乐平台的署名顺序与早期宣传资料不一致，作词方在个人账号表达了疑问。',
      },
      {
        date: '2026-04-06',
        title: '授权范围出现分歧',
        text: '有观点指出该歌曲在短视频平台的使用授权可能超出了原合同约定范围。相关方回应称「正在核对」。',
      },
      {
        date: '2026-06-25',
        title: '分成结算被公开讨论',
        text: '围绕平台结算周期与分成比例，双方各自给出说法。由于合同细节未公开，外界只能通过间接信息推测。',
      },
      {
        date: '2026-08-14',
        title: '进入协商阶段',
        text: '据公开信息，各方已进入协商流程，歌曲在部分平台短暂下架后恢复。后续处理结果尚未公布。',
      },
    ],
  },
  {
    id: 'costume-drama-recast',
    title: '古装大剧换角内幕合集',
    category: '剧组幕后',
    categorySlug: 'production',
    summary:
      '开拍前临时换角、进组后再调整，一部备受期待的古装剧从官宣到杀青经历了好几轮人员变动。这里把公开信息拼成一条完整的时间线。',
    cover:
      'https://readdy.ai/api/search-image?query=Abstract%20cinematic%20film%20set%20with%20vintage%20lights%2C%20wooden%20clapperboard%20and%20warm%20dusty%20sunbeams%20in%20an%20old%20studio%2C%20stylized%20nostalgic%20atmosphere%2C%20muted%20brown%20and%20amber%20palette%2C%20minimal%20composition%2C%20high%20detail&width=900&height=650&seq=guagua-production-04&orientation=landscape',
    tags: ['换角', '开机', '剧本改动', '杀青'],
    updatedAt: '2026-08-09',
    views: 331760,
    entries: [
      {
        date: '2026-01-18',
        title: '首次官宣主演阵容',
        text: '剧方公布主演名单，几位人气演员的组合让项目迅速获得关注。当时物料中的角色设定与后来版本已有不同。',
      },
      {
        date: '2026-03-05',
        title: '开机前传出换角消息',
        text: '有消息称其中一位主演因档期原因退出，剧方未正面回应。随后出现了新的进组路透。',
      },
      {
        date: '2026-05-22',
        title: '剧本调整引发讨论',
        text: '原著粉丝发现部分人物关系与改编方向有明显变化，围绕「魔改」的讨论开始增多。',
      },
      {
        date: '2026-08-09',
        title: '正式杀青',
        text: '剧方发布杀青特辑，最终阵容确认为此前传闻中的版本。剧集上线时间尚未公布。',
      },
    ],
  },
  {
    id: 'variety-editing-row',
    title: '综艺剪辑争议名场面盘点',
    category: '综艺花絮',
    categorySlug: 'variety',
    summary:
      '同一期节目，正片与加更版里嘉宾的表现判若两人。围绕剪辑节奏、镜头分配与字幕引导的讨论，几乎每一季都会重演。',
    cover:
      'https://readdy.ai/api/search-image?query=Abstract%20colorful%20television%20studio%20with%20blurred%20stage%20lights%2C%20warm%20gold%20and%20coral%20glow%20against%20dark%20backdrop%2C%20stylized%20broadcast%20atmosphere%2C%20minimal%20geometric%20composition%2C%20high%20detail&width=900&height=650&seq=guagua-variety-05&orientation=landscape',
    tags: ['剪辑', '镜头分配', '加更版', '字幕'],
    updatedAt: '2026-08-02',
    views: 197540,
    entries: [
      {
        date: '2026-05-12',
        title: '正片播出后嘉宾表现被质疑',
        text: '节目播出后，有观众认为某位嘉宾在正片中存在感偏低，与路透描述不符。',
      },
      {
        date: '2026-05-14',
        title: '加更版内容形成对比',
        text: '加更版放出更多互动片段，画面与正片节奏差异明显，关于剪辑导向的讨论升温。',
      },
      {
        date: '2026-06-30',
        title: '节目组回应剪辑争议',
        text: '节目组表示剪辑以整体叙事节奏为准，会对观众反馈进行复盘。',
      },
      {
        date: '2026-08-02',
        title: '新一季调整镜头逻辑',
        text: '新一季节目中，节目组明显增加了群像戏份，相关争议有所减少。',
      },
    ],
  },
  {
    id: 'dual-endorsement-flop',
    title: '双人代言翻车事件复盘',
    category: '商务代言',
    categorySlug: 'brand',
    summary:
      '一场官宣双代言人的品牌活动，从海报排版到直播顺序都引发了粉丝之间的比较。商业合作里的细节，往往比想象中更容易被放大。',
    cover:
      'https://readdy.ai/api/search-image?query=Abstract%20minimal%20product%20photography%20setup%20with%20a%20blank%20cream%20packaging%20box%20on%20a%20warm%20beige%20surface%2C%20soft%20amber%20side%20light%2C%20clean%20studio%20backdrop%2C%20stylized%20commercial%20still%20life%2C%20high%20detail&width=900&height=650&seq=guagua-brand-06&orientation=landscape',
    tags: ['代言', '海报排版', '直播', '粉丝对比'],
    updatedAt: '2026-07-26',
    views: 168320,
    entries: [
      {
        date: '2026-04-28',
        title: '品牌官宣双代言人',
        text: '品牌同时公布两位代言人，宣传海报采用左右分栏设计，但视觉重心被指略有倾斜。',
      },
      {
        date: '2026-05-10',
        title: '直播出场顺序引讨论',
        text: '首场联合直播中两人的出场与互动时长存在差异，相关话题在粉丝群体中持续发酵。',
      },
      {
        date: '2026-06-15',
        title: '品牌补充说明合作安排',
        text: '品牌方发布说明，表示两位代言人的合作权益完全对等，后续物料会更注重平衡。',
      },
      {
        date: '2026-07-26',
        title: '事件降温，合作继续',
        text: '随着新物料陆续发布，讨论逐渐平息，双方合作按原计划推进。',
      },
    ],
  },
  {
    id: 'girlgroup-departure',
    title: '女团成员退团事件全景',
    category: '事业争议',
    categorySlug: 'career',
    summary:
      '从缺席一场巡演开始，到最终确认退出，中间经历了粉丝请愿、公司说明与本人发文三个阶段。本篇按节点还原整个过程。',
    cover:
      'https://readdy.ai/api/search-image?query=Abstract%20stage%20with%20empty%20microphone%20stands%20and%20warm%20rose%20colored%20spotlights%20in%20haze%2C%20stylized%20concert%20atmosphere%2C%20muted%20coral%20and%20gold%20palette%2C%20minimal%20composition%2C%20high%20detail&width=900&height=650&seq=guagua-career-07&orientation=landscape',
    tags: ['退团', '巡演缺席', '请愿', '官方说明'],
    updatedAt: '2026-07-19',
    views: 289610,
    entries: [
      {
        date: '2026-03-22',
        title: '缺席巡演首站',
        text: '巡演首站演出中该成员未登台，公司以「身体原因」作出简短说明。',
      },
      {
        date: '2026-04-30',
        title: '连续缺席引发猜测',
        text: '后续几场演出同样缺席，粉丝开始组织请愿，希望官方给出更明确的安排。',
      },
      {
        date: '2026-06-08',
        title: '公司发布正式说明',
        text: '公司确认双方就后续发展方向存在分歧，将尊重成员个人意愿。',
      },
      {
        date: '2026-07-19',
        title: '本人发文告别',
        text: '该成员发布长文感谢团队与粉丝，正式确认退出组合。组合随后公布了后续活动安排。',
      },
    ],
  },
  {
    id: 'director-writer-credit',
    title: '导演与编剧的署名之争',
    category: '剧组幕后',
    categorySlug: 'production',
    summary:
      '一部口碑作品上线后，围绕「故事是谁写的」出现了不同说法。署名顺序、改编幅度与实际贡献，成了双方争执的核心。',
    cover:
      'https://readdy.ai/api/search-image?query=Abstract%20writer%20desk%20with%20typewriter%2C%20stack%20of%20screenplays%20and%20a%20storyboard%20lit%20by%20warm%20amber%20lamp%20in%20a%20dim%20room%2C%20stylized%20editorial%20still%20life%2C%20muted%20brown%20and%20gold%20palette%2C%20minimal%20composition%2C%20high%20detail&width=900&height=650&seq=guagua-production-08&orientation=landscape',
    tags: ['署名', '改编', '剧本', '创作贡献'],
    updatedAt: '2026-07-11',
    views: 142870,
    entries: [
      {
        date: '2026-02-08',
        title: '片尾字幕署名顺序被关注',
        text: '作品上线后，有从业者注意到编剧署名顺序与早期立项信息不一致。',
      },
      {
        date: '2026-03-17',
        title: '编剧方发布个人说明',
        text: '编剧一方发表说明，认为自己的原创框架未在最终版本中得到充分体现。',
      },
      {
        date: '2026-05-04',
        title: '导演方回应改编过程',
        text: '导演一方表示拍摄过程中对故事进行了必要调整，署名依据以合同约定为准。',
      },
      {
        date: '2026-07-11',
        title: '双方同意由行业协会协调',
        text: '据公开信息，双方同意通过行业协会的调解机制沟通后续署名与权益问题。',
      },
    ],
  },
  {
    id: 'livestream-data-doubt',
    title: '直播带货数据质疑合集',
    category: '金钱纠葛',
    categorySlug: 'money',
    summary:
      '一场销售额亮眼的直播之后，退货率与人气数据遭到质疑。从战报发布到第三方数据对比，再到平台介入，整个过程颇为曲折。',
    cover:
      'https://readdy.ai/api/search-image?query=Abstract%20modern%20livestream%20setup%20with%20a%20ring%20light%2C%20microphone%20and%20empty%20studio%20background%20in%20warm%20amber%20and%20coral%20glow%2C%20stylized%20commercial%20atmosphere%2C%20minimal%20composition%2C%20high%20detail&width=900&height=650&seq=guagua-money-09&orientation=landscape',
    tags: ['直播', '销售额', '退货率', '数据对比'],
    updatedAt: '2026-07-04',
    views: 175960,
    entries: [
      {
        date: '2026-03-30',
        title: '直播战报公布亮眼数据',
        text: '团队发布直播战报，公布创纪录的销售额。数据迅速被广泛转载。',
      },
      {
        date: '2026-04-11',
        title: '第三方数据出现差异',
        text: '有第三方监测机构给出了与战报差异较大的估算值，关于统计口径的讨论开始出现。',
      },
      {
        date: '2026-05-19',
        title: '退货率被反复提及',
        text: '部分商品的高退货率成为关注焦点，团队回应称属于正常波动范围。',
      },
      {
        date: '2026-07-04',
        title: '平台更新数据口径说明',
        text: '平台发布了新的数据统计说明，明确各项指标的统计方式，相关争议逐步平息。',
      },
    ],
  },
  {
    id: 'award-seating-row',
    title: '颁奖礼座位之争时间线',
    category: '综艺花絮',
    categorySlug: 'variety',
    summary:
      '一张座位图，足以引发整晚的讨论。从前排排位到镜头分配，颁奖礼的每个细节都会被放大解读。',
    cover:
      'https://readdy.ai/api/search-image?query=Abstract%20red%20carpet%20event%20hall%20with%20empty%20velvet%20seats%20and%20warm%20golden%20spotlights%2C%20stylized%20awards%20ceremony%20atmosphere%2C%20muted%20coral%20and%20cream%20palette%2C%20minimal%20composition%2C%20high%20detail&width=900&height=650&seq=guagua-variety-10&orientation=landscape',
    tags: ['颁奖礼', '座位', '镜头', '排位'],
    updatedAt: '2026-06-27',
    views: 210480,
    entries: [
      {
        date: '2026-02-25',
        title: '座位图提前流出',
        text: '典礼开始前，一张座位安排图在网络流传，前排位置分配引发讨论。',
      },
      {
        date: '2026-02-26',
        title: '直播镜头分配被统计',
        text: '有网友统计了整场直播中不同嘉宾的镜头时长，数据差异成为新的话题点。',
      },
      {
        date: '2026-03-06',
        title: '主办方回应安排原则',
        text: '主办方表示座位与镜头安排综合考虑了作品、资历与现场调度等多重因素。',
      },
      {
        date: '2026-06-27',
        title: '新一届调整座位规则',
        text: '新一届典礼公布了更透明的座位编排说明，相关讨论明显减少。',
      },
    ],
  },
];

export const collectionCount = collections.length;